import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('authorization');

export default {
  computed: {
    ...mapGetters([
      'domain',
      'login',
      'userName',
      'token',
      'data',
      'isAdministrator',
      'isApproving',
      'isApproverAdm',
    ]),
  },
};
